document.addEventListener("DOMContentLoaded", function () {
 
  //open dropdown

  const dropdowns = document.querySelectorAll(".filter-dropdown");

  dropdowns.forEach((dropdown) => {
    const button = dropdown.querySelector(".filter-dropdown__button");

    button.addEventListener("click", function (event) {
      event.stopPropagation();

      dropdowns.forEach((d) => {
        if (d !== dropdown) {
          d.classList.remove("open");
          d.querySelector(".filter-dropdown__button").classList.remove(
            "active"
          );

          const dContent = d.querySelector(".filter-dropdown__content");
          if (dContent) {
            dContent.scrollTop = 0;
          }
        }
      });

      const isOpen = dropdown.classList.contains("open");

      dropdown.classList.toggle("open");
      button.classList.toggle("active");

      if (isOpen) {
        const dropdownContent = dropdown.querySelector(
          ".filter-dropdown__content"
        );
        if (dropdownContent) {
          dropdownContent.scrollTop = 0;
        }
      }
    });

    const dropdownContent = dropdown.querySelector(".filter-dropdown__content");
    dropdownContent.addEventListener("click", function (event) {
      event.stopPropagation();
    });
  });

  document.addEventListener("click", function () {
    dropdowns.forEach((dropdown) => {
      dropdown.classList.remove("open");
      dropdown
        .querySelector(".filter-dropdown__button")
        .classList.remove("active");

      const dropdownContent = dropdown.querySelector(
        ".filter-dropdown__content"
      );
      if (dropdownContent) {
        dropdownContent.scrollTop = 0;
      }
    });
  });

  //change variant price
  const lengthInputs = document.querySelectorAll(".variant-length__input");

  lengthInputs.forEach((input) => {
    input.addEventListener("change", function () {
      const newPrice = this.getAttribute("data-price");

      const variantCard = this.closest(".variant-card");
      if (variantCard) {
        const priceElement = variantCard.querySelector(".variant-price");
        if (priceElement) {
          priceElement.textContent = newPrice;
        }
      }
    });
  });

  //add to cart
  const addToCartButtons = document.querySelectorAll(
    ".variant-card__add-to-card button"
  );

  addToCartButtons.forEach((button) => {
    button.addEventListener("click", async function () {
      this.classList.add("btn--loading");
      const productTitle = this.dataset.productName;
      let productId =
        this.closest(".variant-card")
          .querySelector(".variant-length input:checked")
          ?.getAttribute("data-id") || this.dataset.id;

      let data = [
        {
          id: productId,
          quantity: 1,
        },
      ];

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: data,
          }),
        });

        if (response.ok) {
          try {
            const cartResponse = await fetch(
              window.Shopify.routes.root + "cart.js",
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            if (cartResponse.ok) {
              const cartData = await cartResponse.json();
              const itemCount = cartData.item_count;
              document.querySelector(".header-cart_item-count").textContent =
                itemCount;
            }
          } catch (cartError) {
            console.error("Cart Fetch Error:", cartError);
          }

          document.querySelector(
            ".added-notification_product-title"
          ).innerHTML = productTitle;
          document.querySelector(".added-notification").classList.add("active");
          setTimeout(() => {
            document
              .querySelector(".added-notification")
              .classList.remove("active");
          }, 6000);
        } else {
          console.error("Response not OK. Status Code:", response.status);
        }
      } catch (error) {
        console.error("Fetch Error:", error);
      } finally {
        this.classList.remove("btn--loading");
      }
    });
  });

  //clear all filters

  document.querySelectorAll(".clear-all").forEach((clearButton) => {
    clearButton.addEventListener("click", () => {
      document
        .querySelectorAll(".filter-dropdown__content .filter-checkbox")
        .forEach((checkbox) => {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event("change"));
        });
    });
  });

  // filtering for desktop

  if (window.innerWidth >= 576) {
    document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
      const checkboxes = dropdown.querySelectorAll(".filter-checkbox");
      const button = dropdown.querySelector(".filter-dropdown__button");
      const svgIcon = button.querySelector("svg");
      const products = document.querySelectorAll(".variant-card");
      const noResultText = document.querySelector(".no-result__text");
      const productList = document.querySelector(
        ".cm-variant-grid__products-grid"
      );

      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
          let selectedFilters = {};

          document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
            const type = dropdown
              .querySelector(".filter-dropdown__button")
              .getAttribute("data-filter-type")
              .toLowerCase();
            const selectedCheckboxes = Array.from(
              dropdown.querySelectorAll(".filter-checkbox:checked")
            );
            selectedFilters[type] = selectedCheckboxes.map((cb) =>
              cb.getAttribute(`data-${type}`)
            );
          });

          let selectedCheckboxes = Array.from(checkboxes).filter(
            (cb) => cb.checked
          );
          button.innerHTML = "";

          if (selectedCheckboxes.length > 0) {
            const firstLabel =
              selectedCheckboxes[0].previousElementSibling.textContent;
            const count = selectedCheckboxes.length - 1;

            button.classList.add("selected");
            button.append(firstLabel);

            if (count > 0) {
              const countSpan = document.createElement("span");
              countSpan.classList.add("filter-count");
              countSpan.textContent = ` +${count}`;
              button.appendChild(countSpan);
            }

            button.appendChild(svgIcon);
          } else {
            button.classList.remove("selected");
            button.innerHTML = `Filter By ${button.getAttribute(
              "data-filter-type"
            )} `;
            button.appendChild(svgIcon);
          }

          products.forEach((product) => {
            let productColor = product.getAttribute("data-color") || "";
            let productCategory = product.getAttribute("data-category") || "";
            let productLengths = product.getAttribute("data-lengths") || "";
            let productCollection =
              product.getAttribute("data-collection") || "";

            let matchesColor =
              selectedFilters.color.length === 0 ||
              (productColor && selectedFilters.color.includes(productColor));

            let matchesCategory =
              selectedFilters.category.length === 0 ||
              (productCategory &&
                selectedFilters.category.some((cat) =>
                  productCategory.includes(cat)
                ));

            let productCollections = productCollection
              .split(",")
              .map((col) => col.trim());

            let matchesCollection =
              selectedFilters.collection.length === 0 ||
              selectedFilters.collection.some((col) =>
                productCollections.includes(col)
              );

            let productLengthsArray = productLengths
            ? productLengths.split(",").map((len) => len.trim())
            : [];

            let matchesLength =
              selectedFilters.length?.length === 0 ||
              selectedFilters.length?.some((len) =>
              productLengthsArray.includes(len)
            );

            if (matchesColor && matchesCategory && matchesCollection && matchesLength) {
              product.style.display = "flex";
            } else {
              product.style.display = "none";
            }
          });

          let visibleProducts = Array.from(products).filter(
            (product) => product.style.display !== "none"
          );

          if (visibleProducts.length === 0) {
            noResultText.classList.add("active");
            productList.style.display = "none";
          } else {
            noResultText.classList.remove("active");
            productList.style.display = "grid";
          }
        });
      });
    });
  }

  // filtering for mobile

  const filterBtn = document.getElementById("filterToggle");
  const filterForm = document.getElementById("filterForm");
  const closeFilter = document.getElementById("closeFilter");
  const footerShowButton = document.querySelector(".mobile-form__footer-show");
  const footerShowSpan = document.querySelector(
    ".mobile-form__footer-show span"
  );
  const body = document.body;

  function openFilter() {
    if (window.matchMedia("(max-width: 576px)")) {
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    }

    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        document.querySelector("header").getBoundingClientRect().bottom
      )}px`
    );

    filterForm.classList.add("active");
    body.classList.add("overflow-hidden-tablet");
  }

  function closeFilterMenu() {
    filterForm.classList.remove("active");
    body.classList.remove("overflow-hidden-tablet");
    filterSections.forEach((section) => {
      section.classList.remove("active");
      section.querySelector(".accordion-content").style.maxHeight = "0";
    });
  }
  

  filterBtn?.addEventListener("click", openFilter);
  closeFilter?.addEventListener("click", closeFilterMenu);

  const filterSections = document.querySelectorAll(".accordion-item");
  const products = document.querySelectorAll(".variant-card");
  const noResultText = document.querySelector(".no-result__text");
  const productList = document.querySelector(".cm-variant-grid__products-grid");

  function updateFilterCount() {
    filterSections.forEach((section) => {
      const checkboxes = section.querySelectorAll(".mobile-filter-checkbox");
      const headerSpan = section.querySelector(".accordion-header span");
      const activeCount = Array.from(checkboxes).filter(
        (cb) => cb.checked
      ).length;
      headerSpan.textContent = activeCount > 0 ? `${activeCount}` : "";
    });

    updateVisibleCount();
  }

  function updateVisibleCount() {
    let selectedFilters = {};
    let hasSelectedCheckbox = false;

    filterSections.forEach((section) => {
      const type = section
        .querySelector(".accordion-header")
        .getAttribute("data-filter-type")
        .toLowerCase();
      const selectedCheckboxes = Array.from(
        section.querySelectorAll(".mobile-filter-checkbox:checked")
      );

      selectedFilters[type] = selectedCheckboxes.map((cb) =>
        cb.getAttribute(`data-${type}`)
      );

      if (selectedCheckboxes.length > 0) {
        hasSelectedCheckbox = true;
      }
    });

    if (!hasSelectedCheckbox) {
      footerShowSpan.textContent = "";
      return;
    }

    let visibleCount = 0;
    products.forEach((product) => {
      let productColor = product.getAttribute("data-color") || "";
      let productCategory = product.getAttribute("data-category") || "";
      let productCollection = product.getAttribute("data-collection") || "";
      let productLengths = product.getAttribute("data-lengths") || "";
      let productLengthsArray = productLengths
        ? productLengths.split(",").map((len) => len.trim())
        : [];

      let matchesLength =
        selectedFilters.length?.length === 0 ||
        selectedFilters.length?.some((len) =>
          productLengthsArray.includes(len)
        );

      let matchesColor =
        selectedFilters.color.length === 0 ||
        (productColor && selectedFilters.color.includes(productColor));

      let matchesCategory =
        selectedFilters.category.length === 0 ||
        (productCategory &&
          selectedFilters.category.some((cat) =>
            productCategory.includes(cat)
          ));

      let productCollections = productCollection
        .split(",")
        .map((col) => col.trim());

      let matchesCollection =
        selectedFilters.collection.length === 0 ||
        selectedFilters.collection.some((col) =>
          productCollections.includes(col)
        );

      if (matchesColor && matchesCategory && matchesCollection && matchesLength) {
        visibleCount++;
      }
    });

    footerShowSpan.textContent = `(${visibleCount})`;
  }

  function updateVisibleProducts() {
    let selectedFilters = {};
    filterSections.forEach((section) => {
      const type = section
        .querySelector(".accordion-header")
        .getAttribute("data-filter-type")
        .toLowerCase();
      const selectedCheckboxes = Array.from(
        section.querySelectorAll(".mobile-filter-checkbox:checked")
      );
      selectedFilters[type] = selectedCheckboxes.map((cb) =>
        cb.getAttribute(`data-${type}`)
      );
    });

    let visibleCount = 0;
    products.forEach((product) => {
      let productColor = product.getAttribute("data-color") || "";
      let productCategory = product.getAttribute("data-category") || "";
      let productCollection = product.getAttribute("data-collection") || "";
      let productLengths = product.getAttribute("data-lengths") || "";

      let productCollections = productCollection
        .split(",")
        .map((col) => col.trim());

      let productLengthsArray = productLengths
        ? productLengths.split(",").map((len) => len.trim())
        : [];

      let matchesColor =
        selectedFilters.color.length === 0 ||
        (productColor && selectedFilters.color.includes(productColor));

      let matchesCategory =
        selectedFilters.category.length === 0 ||
        (productCategory &&
          selectedFilters.category.some((cat) =>
            productCategory.includes(cat)
          ));

      let matchesCollection =
        selectedFilters.collection.length === 0 ||
        selectedFilters.collection.some((col) =>
          productCollections.includes(col)
        );

      let matchesLength =
        selectedFilters.length?.length === 0 ||
        selectedFilters.length?.some((len) =>
          productLengthsArray.includes(len)
        );

      if (matchesColor && matchesCategory && matchesCollection && matchesLength) {
        product.style.display = "flex";
        visibleCount++;
      } else {
        product.style.display = "none";
      }
    });

    if (visibleCount === 0) {
      noResultText.classList.add("active");
      productList.style.display = "none";
    } else {
      noResultText.classList.remove("active");
      productList.style.display = "grid";
    }

    closeFilterMenu();
  }

  filterSections.forEach((section) => {
    const checkboxes = section.querySelectorAll(".mobile-filter-checkbox");
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", updateFilterCount);
    });
  });

  function updateMobileFilterCount() {
    let activeFilters = 0;

    filterSections.forEach((section) => {
      const checkboxes = section.querySelectorAll(
        ".mobile-filter-checkbox:checked"
      );
      activeFilters += checkboxes.length;
    });

    let countSpan = filterBtn.querySelector(".filter-count");

    if (activeFilters > 0) {
      if (!countSpan) {
        countSpan = document.createElement("span");
        countSpan.classList.add("filter-count");
        filterBtn.appendChild(countSpan);
        filterBtn.classList.add("active");
      }
      countSpan.textContent = ` ${activeFilters}`;
    } else if (countSpan) {
      countSpan.remove();
      filterBtn.classList.remove("active");
    }
  }

  footerShowButton?.addEventListener("click", () => {
    updateVisibleProducts();
    updateMobileFilterCount();
  });

  const footerClearButton = document.querySelector(
    ".mobile-form__footer-clear"
  );

  footerClearButton?.addEventListener("click", function () {
    const headerSpan = document.querySelectorAll(".accordion-header span");
    headerSpan.forEach((item) => {
      item.textContent = "";
    });
    footerShowSpan.textContent = "";
    closeFilterMenu();

    filterSections.forEach((section) => {
      const checkboxes = section.querySelectorAll(".mobile-filter-checkbox");
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    });

    products.forEach((product) => {
      product.style.display = "flex";
    });

    noResultText.classList.remove("active");
    productList.style.display = "grid";
    updateMobileFilterCount();
  });

  // filters accordion

  document.querySelectorAll(".accordion-header").forEach((button) => {
    button.addEventListener("click", function () {
      const item = this.parentElement;
      const content = this.nextElementSibling;

      if (item.classList.contains("active")) {
        content.style.maxHeight = "0";
        item.classList.remove("active");
      } else {
        document.querySelectorAll(".accordion-item").forEach((i) => {
          i.classList.remove("active");
          i.querySelector(".accordion-content").style.maxHeight = "0";
        });
        item.classList.add("active");
        content.style.maxHeight = `${content.scrollHeight + 20}px`;
      }
    });
  });
});
